import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import HomePage from './pages/HomePage.jsx';
import Blog from './components/Blog.jsx';
import BlogPost from './components/BlogPost.jsx';
import DrivewayWashingPage from './pages/DrivewayWashingPage.jsx';
import PatioCleaningPage from './pages/PatioCleaningPage.jsx';
import GutterCleaningPage from './pages/GutterCleaningPage.jsx';
import RoofCleaningPage from './pages/RoofCleaningPage.jsx';
import SolarPanelCleaningPage from './pages/SolarPanelCleaningPage.jsx';
import ResidentialCleaningPage from './pages/ResidentialCleaningPage.jsx';
import './styles/main.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/services/driveway-washing" element={<DrivewayWashingPage />} />
            <Route path="/services/patio-cleaning" element={<PatioCleaningPage />} />
            <Route path="/services/gutter-cleaning" element={<GutterCleaningPage />} />
            <Route path="/services/roof-cleaning" element={<RoofCleaningPage />} />
            <Route path="/services/solar-panel-cleaning" element={<SolarPanelCleaningPage />} />
            <Route path="/services/residential-cleaning" element={<ResidentialCleaningPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;